import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { AssistantUiProvider } from "@/features/assistant/assistant-context";
import { AssistantPanel } from "@/features/assistant/AssistantPanel";

export function AppShell() {
  return (
    <AssistantUiProvider>
      <div className="flex min-h-screen bg-ge-app">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          <main className="flex-1 overflow-y-auto px-6 py-9 lg:px-12">
            <Outlet />
          </main>
        </div>
      </div>
      <AssistantPanel />
    </AssistantUiProvider>
  );
}
